import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    nuser_in: false,
  },
  getters: {},
  mutations: {
    setNuser_in(state, value) {
      state.nuser_in = value;
    }
  },
  actions: {
    updateNuser_in({ commit }, value) {
      commit('setNuser_in', value);
    }
  },
  modules: {},
});
